import { useEffect, useRef } from 'react';
import { useRealtimeHub } from '../context/RealtimeContext';

/**
 * Subscribe to the shared realtime bus (`/api/ws`) without opening a new socket.
 *
 * @param {Set<string>|string[]} eventTypes
 * @param {(data: { type: string }) => void} onEvent
 * @param {{ enabled?: boolean }} [options]
 */
export default function useRealtimeEvents(eventTypes, onEvent, options = {}) {
  const { enabled = true } = options;
  const { subscribe } = useRealtimeHub();
  const onEventRef = useRef(onEvent);
  const typesRef = useRef(eventTypes);

  useEffect(() => {
    onEventRef.current = onEvent;
  }, [onEvent]);

  useEffect(() => {
    typesRef.current = eventTypes;
  }, [eventTypes]);

  useEffect(() => {
    if (!enabled) return undefined;

    return subscribe(null, (data) => {
      const types = typesRef.current;
      const ok = !types
        || (types instanceof Set ? types.has(data.type) : types.includes(data.type));
      if (ok) onEventRef.current?.(data);
    });
  }, [enabled, subscribe]);
}
